module.exports = {"513324100":"呷尔镇","513324101":"烟袋镇","513324102":"三垭镇","513324103":"雪洼龙镇","513324104":"湾坝镇","513324105":"汤古镇","513324106":"乌拉溪镇","513324107":"魁多镇","513324108":"乃渠镇","513324202":"三岩龙乡","513324203":"上团乡","513324204":"八窝龙乡","513324209":"子耳彝族乡","513324212":"小金彝族乡","513324213":"朵洛彝族乡","513324216":"洪坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513324.json
// module id = 2546
// module chunks = 0